import React, { useCallback, useEffect, useMemo, useState } from "react";
import MicroOptMetrics from "../../Microgrid-Opt-Components/Metrics/metrics";
import { EMCORE_DASHBOARD_BASE_API_URL } from "../../../strings";


function MetricsContainer() {
  const initialMetricsData = useMemo(
    () => ({
      currentPowerOutput: [{ metricName: "# Current Power Output", metricScore: "N/A", metricStat: "" }],
      P50Forcast: [{ metricName: "# P50 Forcast", metricScore: "N/A", metricStat: "" }],
      avgIrradiance: [{ metricName: "# Avg Irradiance", metricScore: "N/A", metricStat: "" }],
      cloudCover: [{ metricName: "# Cloud Cover %", metricScore: "N/A", metricStat: "" }],
      forcastAccuracy: [{ metricName: "# Forcast Accuracy", metricScore: "N/A", metricStat: "" }],
      gridFrequency: [{ metricName: "# Grid Frequency", metricScore: "N/A", metricStat: "" }]
    }),
    []
  );

  const [actualMetrics, setActualMetrics] = useState(initialMetricsData);
  const isFileUploaded = useMemo(() => JSON.parse(localStorage.getItem("isFileUploaded")), []);

  const fetchMetricsData = useCallback(async () => {
    try {
      const metricsApiResponse = "";
      const metricsKeys = {
        currentPowerOutput: "Current_Power_Output",
        P50Forcast: "P50_Forcast",
        avgIrradiance: "Avg_Irradiance",
        cloudCover: "Cloud_Cover",
        forcastAccuracy: "Forcast_Accuracy",
        gridFrequency: "Grid_Frequency",
      };

      const combinedMetrics = Object.entries(metricsKeys).reduce((acc, [key, apiKey]) => {
        acc[key] = [
          {
            metricName: initialMetricsData[key][0].metricName,
            metricScore: isFileUploaded ? metricsApiResponse[apiKey]?.value : "N/A",
            metricStat: isFileUploaded ? metricsApiResponse[apiKey]?.unit : ""
          }
        ];
        return acc;
      }, {});

      setActualMetrics(combinedMetrics);
    } catch (error) {
      console.error("Error fetching the JSON data:", error);
    }
  }, [isFileUploaded, initialMetricsData]);

  useEffect(() => {
    fetchMetricsData();
  }, [fetchMetricsData]);

  const metricComponents = useMemo(
    () =>
      Object.entries(actualMetrics).map(([key, legends], index) => (
        <div
          key={key}
          className="col-sm-6 col-md-4 col-lg-4 col-xl-2 metrics"
          style={{ paddingLeft: "8px", marginLeft: index === 0 || index === 5 ? "24px" : "0px" }}
        >
          <MicroOptMetrics position={3} legends={legends} />
        </div>
      )),
    [actualMetrics]
  );

  return <div className="filter-row row" style={{ zIndex: "-1" }}>{metricComponents}</div>;
}

export default MetricsContainer;
